<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import JevEntries from "@/components/widgets/jev-entries.vue";
import JevModal from "@/components/modals/jev-modal.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import FinanceAttachments from "@/components/modals/finance-attachments.vue";
import Swal from "sweetalert2";
import UploadModal from "@/components/modals/upload-stock.vue";

export default {
    name: "jev",
    components: {
        Layout,
        PageHeader,
        JevEntries,
        JevModal,
        PrintOptions,
        FinanceAttachments,
        UploadModal,
    },
    data() {
        return {
            title: "Journal Entries",
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Journal Entries",
                    active: true,
                },
            ],
            loading: false,
            jevEntries: [],
            journals: [],
            fundSources: [],
            accounts: [],
            tabModel: 0,
            modalTitle: "",
            selectedJournal: {},
            selectedFSId: 0,
            uploaded: false,
        };
    },
    computed: {
        fundSourceOptions() {
            return [
                { value: 0, text: 'Select Fund Source...', disabled: true },
                ...this.fundSources.map(fs => ({ value: fs.id, text: fs.sourceName }))
            ];
        },
    },
    watch: {
        tabModel: async function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.loading = true;
                this.jevEntries = [];
                if(newVal == 0){
                    await this.getDraftJevEntries(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                } else {
                    await this.getPostedJevEntries(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                }
                this.loading = false;
            }
        },
    },
    async created(){
        this.loading = true;
        await this.changeData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        this.loading = false;
        await this.fetchAccounts();
        await this.getJournalTypes();
    },
    methods: {
        async getJournalTypes(){
            await this.$store
                .dispatch("journaltypes/GetJournalTypes")
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.journals = res.data;
                    this.selectedJournal = this.journals[0] || {};
                })
                .catch((err) => {
                    this.showToast("Something went wrong", "error");
                })
        },
        async changeData(cycle, campusId) {
            this.loading = true;
            await this.getFundSources(campusId);
            if(this.tabModel == 0){
                await this.getDraftJevEntries(cycle, campusId);
            } else {
                await this.getPostedJevEntries(cycle, campusId);
            }
            this.loading = false;
        },
        async getDraftJevEntries(cycle, campusId) {
            await this.$store.dispatch("jev/getDraftJevEntries", { cycle, campusId })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.opened = false;
                        item.showPopover = false;
                        item.selected = false;
                    });
                    this.jevEntries = res.data.sort((a, b) => new Date(b.jevDate) - new Date(a.jevDate));
                })
                .catch((err) => {
                    this.showToast("Error fetching Draft Journal Entries", "error");
                });
        },
        async getPostedJevEntries(cycle, campusId) {
            await this.$store.dispatch("jev/getPostedJevEntries", { cycle, campusId })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.opened = false;
                        item.showPopover = false;
                        item.selected = false;
                    });
                    this.jevEntries = res.data.sort((a, b) => new Date(b.jevDate) - new Date(a.jevDate));
                })
                .catch((err) => {
                    this.showToast("Error fetching Posted Journal Entries", "error");
                });
        },
        async getFundSources(id){
            await this.$store
                .dispatch("fundsource/GetActiveFundSourcesByCampusId", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.fundSources = res.data
                })
                .catch((err) => {
                    this.showToast("Failed to fetch fund sources. Please contact administrator", "error");
                });
        },
        async fetchAccounts(){
            await this.$store
                .dispatch("accounts/getAllAccounts")
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.accounts = res.data;
                })
            .catch((error) => {
                this.showToast("Cannot fetch accounts. Please contact your administrator", "error");
            });
        },
        addJEVEntry() {
            this.modalTitle = `Add Journal Entry`;
            this.$bvModal.show("jev-modal");
            this.$refs.jevModal.resetForm();
            this.$refs.jevModal.generateJevNumber();
        },
        async submitJevEntry(modalData){
            modalData.campusId = this.$store.state.data.selectedCampus.id;
            if(modalData.id > 0){
                await this.$store
                    .dispatch("jev/updateJevEntry", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.jevEntries.findIndex(x => x.id === modalData.id);
                        if(index > -1){
                            modalData.journalType = this.journals.find(x => x.id === modalData.journalId)?.journalTypeName || '';
                            this.jevEntries.splice(index, 1, modalData);
                        }
                        this.showToast("Journal Entry updated successfully!", "success");
                        this.$bvModal.hide("jev-modal");
                    })
                    .catch((err) => {
                        this.showToast("Error updating Journal Entry", "error");
                    });
            }else{
                await this.$store
                    .dispatch("jev/createJevEntry", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        if(!modalData.createAndPost){
                            res.data.opened = false;
                            res.data.showPopover = false;
                            this.jevEntries.unshift(res.data);
                        }
                        this.showToast("Journal Entry added successfully!", "success");
                        this.$bvModal.hide("jev-modal");
                    })
                    .catch((err) => {
                        this.showToast("Error adding Journal Entry", "error");
                    });
            }
        },
        editJevEntry(item){
            let data = JSON.parse(JSON.stringify(item));
            data.jevDate = new Date(item.jevDate);
            data.jevDetails = data.jevDetails.map(detail => {
                return {
                    ...detail,
                    debit: detail.debit.toString(),
                    credit: detail.credit.toString(),
                    accountName: detail.account,
                    isEdit: false
                };
            });
            this.modalTitle = `Edit Journal Entry`;
            this.$bvModal.show("jev-modal");
            this.$refs.jevModal.updateData(data);
        },
        deleteJevEntry(item) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("jev/deleteJevEntry", item.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = this.jevEntries.findIndex(x => x.id === item.id);
                            if(index > -1){
                                this.jevEntries.splice(index, 1);
                            }
                            this.showToast("Journal Entry deleted successfully!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Error deleting Journal Entry", "error");
                        });
                }
            });
        },
        postJevEntry(item) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this after posting!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28c76f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("jev/postJevEntry", item.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = this.jevEntries.findIndex(x => x.id === item.id);
                            if(index > -1){
                                this.jevEntries.splice(index, 1);
                            }
                            this.showToast("Journal Entry posted successfully!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Error posting Journal Entry", "error");
                        });
                }
            });
        },
        postJevEntries(items){
            let ids = items.map(i => { return {id: i.id} });
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this after posting!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28c76f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("jev/postMultipleJevEntries", ids)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            ids.forEach(idObj => {
                                let index = this.jevEntries.findIndex(x => x.id === idObj.id);
                                if(index > -1){
                                    this.jevEntries.splice(index, 1);
                                }
                            });
                            this.showToast("Journal Entry posted successfully!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Error posting Journal Entry", "error");
                        });
                }
            });
        },
        deleteJevEntries(items){
            let ids = items.map(i => { return {id: i.id} });
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("jev/deleteMultipleJevEntries", ids)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            ids.forEach(idObj => {
                                let index = this.jevEntries.findIndex(x => x.id === idObj.id);
                                if(index > -1){
                                    this.jevEntries.splice(index, 1);
                                }
                            });
                            this.showToast("Journal Entry deleted successfully!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Error deleting Journal Entry", "error");
                        });
                }
            });
        },
        printJevEntry(item){
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/JEV",
                routeVariables: [item.id],
                body: {
                    body: item.id
                },
            });
            this.$bvModal.show("print-options-modal");
        },
        getAttachments(data){
            this.$refs.finAttach.setUploadOpt({
                type: "JEV",
                placement: "left",
                folder: "Finance",
            });
            this.$refs.finAttach.getAttachments(data.att, data.id);
            this.$bvModal.show("finance-attachment-modal");
        },
        uploadEntries() {
            this.selectedFSId = 0;
            this.uploaded = false;
            this.$bvModal.show("modal-excel");
        },
        async uploadExcel(arr){
            let finArr = [];
            let errors = [];
            let currentEntry = null;
            this.uploaded = true;
            if(this.selectedFSId === 0){
                return;
            }
            this.uploaded = false;
            
            arr.forEach((row, index) => {
                const hasType = row['Type'] && row['Type'].toString().trim() !== '';
                const hasUACS = row['UACS'] && row['UACS'].toString().trim() !== '';
                if (hasType) {
                    let typeExist = this.journals.find(journal => journal.shortName.toLowerCase() === row['Type'].toString().toLowerCase());
                    let id = 0;
                    if(typeExist){
                        id = typeExist.id;
                    }else{
                        errors.push(`Journal type in row ${index + 2} (${row['Type']}) does not exist in GIAMS.`);
                    }
                    currentEntry = {
                        jevDate: this.getDate(new Date(row['Date'])),
                        jevNumber: row['JEV No'],
                        description: row['Description'],
                        sourceDocument: row['Source Reference'],
                        responsibilityCenter: '',
                        journalTypeId: id,
                        fundSourceId: this.selectedFSId,
                        createAndPost: false,
                        jevDetails: []
                    };
                    finArr.push(currentEntry);
                    if (hasUACS) {
                        let accountId = 0;
                        let uacsExist = this.accounts.find(acc => acc.uacs.replace(/\s/g, '') === row['UACS'].toString().replace(/\s/g, ''));
                        if (uacsExist) {
                            accountId = uacsExist.id;
                        }else{
                            errors.push(`UACS code in row ${index + 2} does not exist in GIAMS.`);
                        }
                        currentEntry.jevDetails.push({
                            accountId: accountId,
                            uacs: row['UACS'],
                            account: row['Account'],
                            debit: row['Debit'] || 0,
                            credit: row['Credit'] || 0
                        });
                    }
                } else if (hasUACS && currentEntry) {
                    let accountId = 0;
                    let uacsExist = this.accounts.find(acc => acc.uacs.replace(/\s/g, '') === row['UACS'].toString().replace(/\s/g, ''));
                    if (uacsExist) {
                        accountId = uacsExist.id;
                    }else{
                        errors.push(`UACS code in row ${index + 2} (${row['UACS']}) does not exist in GIAMS.`);
                    }
                    currentEntry.jevDetails.push({
                        accountId: accountId,
                        uacs: row['UACS'],
                        account: row['Account'],
                        debit: row['Debit'] || 0,
                        credit: row['Credit'] || 0
                    });
                }
            });
            if (errors.length > 0) {
                this.showToast(errors.join('\n'), 'error', 10000);
                return;
            }
            await this.$store
                .dispatch("jev/uploadJevEntries", {arr: finArr, campusId: this.$store.state.data.selectedCampus.id})
                .then(async (res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.showToast("Journal Entries uploaded successfully!", "success");
                    this.$bvModal.hide("modal-excel");
                    this.loading = true;
                    await this.getDraftJevEntries(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                    this.loading = false;
                })
                .catch((err) => {
                    this.showToast("Error uploading Journal Entries", "error");
                });
        },
    },
};
</script>

<template>
    <Layout 
        @changeCycle="changeData($event, $store.state.data.selectedCampus.id)"
        @changeCampus="changeData($store.state.data.cycle, $event.id)"
    >
        <PageHeader :title="title" :items="items" />
        
        <b-tabs
            v-model="tabModel"
            pills
            vertical
            nav-class="p-0"
            nav-wrapper-class="col-sm-2 border-end"
            content-class="pt-0 px-2 text-muted"
        >
            <b-tab>
                <template v-slot:title>
                    <i class="mdi mdi-file-document-edit me-1"></i>
                    <span>Draft</span>
                </template>
                <JevEntries 
                    :loading="loading"
                    type="general"
                    from="jev"
                    statusType="draft"
                    :entries="jevEntries"
                    :journals="journals"
                    @edit-entry="editJevEntry"
                    @delete-entry="deleteJevEntry"
                    @post-entry="postJevEntry"
                    @print="printJevEntry"
                    @add-entry="addJEVEntry"
                    @attachment="getAttachments"
                    @upload-excel="uploadEntries"
                    @bulk-post="postJevEntries"
                    @bulk-remove="deleteJevEntries"
                />
            </b-tab>
            
            <b-tab>
                <template v-slot:title>
                    <i class="mdi mdi-check-circle me-1"></i>
                    <span>Posted</span>
                </template>
                <JevEntries 
                    from="jev"
                    statusType="posted"
                    :loading="loading"
                    :entries="jevEntries"
                    :journals="journals"
                    @print="printJevEntry"
                    @attachment="getAttachments"
                />
            </b-tab>
        </b-tabs>

        <JevModal 
            ref="jevModal" 
            :modalTitle="modalTitle"
            :fundSources="fundSources"
            :accounts="accounts"
            :journals="journals"
            @submit="submitJevEntry"
        />
        <PrintOptions ref="printOpt" />
        <FinanceAttachments 
            ref="finAttach"
            :wActions="true"
        />
        <UploadModal @upload-excel="uploadExcel">
            <template v-slot:additional>
                <div class="mt-3">
                    <label for="fundSource">Fund Source </label>
                    <b-form-select
                        class="form-select"
                        id="fundSource"
                        v-model="selectedFSId"
                        :options="fundSourceOptions"
                        autocomplete="off"
                        :class="{
                            'is-invalid': selectedFSId === 0 && uploaded,
                        }"
                    />
                    <div
                        v-if="selectedFSId === 0 && uploaded"
                        class="invalid-feedback"
                    >
                        <span v-if="selectedFSId === 0">This value is required.</span>
                    </div>
                </div>
            </template>
        </UploadModal>
    </Layout>
</template>